import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/dictionary/highSchool/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/dictionary/highSchool', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/dictionary/highSchool', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/dictionary/highSchool/' + id)
  }
}
